const getters = {
    isCollapse: state => state.isCollapse
}

export default getters